export enum Endpoints {
  ARTICLES = "articles",
  COMMANDES = "commandes",
  METIERS = "metiers",
  USERS = "users",
}
